import { render, staticRenderFns } from "./mdHoldupTable.vue?vue&type=template&id=00ce2ca6&scoped=true"
import script from "./mdHoldupTable.vue?vue&type=script&lang=js"
export * from "./mdHoldupTable.vue?vue&type=script&lang=js"
import style0 from "./mdHoldupTable.vue?vue&type=style&index=0&id=00ce2ca6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00ce2ca6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00ce2ca6')) {
      api.createRecord('00ce2ca6', component.options)
    } else {
      api.reload('00ce2ca6', component.options)
    }
    module.hot.accept("./mdHoldupTable.vue?vue&type=template&id=00ce2ca6&scoped=true", function () {
      api.rerender('00ce2ca6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/collectionCenter/CollectKanban/mdHoldupTable.vue"
export default component.exports